import {
    ChangeDetectorRef,
    Component,
    ComponentRef,
    HostBinding,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewChild,
    ViewContainerRef,
} from '@angular/core';
import {HtmlAnchorDirective} from './directives/html-anchor.directive';
import {DocumentHostClassesEnum} from './enums/document-host-classes.enum';
import {DynamicComponentInterface, JitComponentFactory} from './factories/jit-component.factory';
import {ApiDocumentDataInterface} from './interfaces/api_v1';
import {ClassHelper} from '@shared/modules/content/modules/helpers/dom/class.helper';

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
})
export class ContentComponent implements OnInit, OnChanges {
    @ViewChild(HtmlAnchorDirective, {read: ViewContainerRef, static: true})
    private htmlAnchor!: ViewContainerRef;

    readonly #cdr: ChangeDetectorRef;

    private static jitComponent?: ComponentRef<DynamicComponentInterface>;

    @Input()
    public document!: ApiDocumentDataInterface;

    @Input()
    public dpsid!: string;

    @Input()
    public classModifiers: string[] = [];

    @HostBinding('class')
    public elementClass: string = DocumentHostClassesEnum.Document;

    public constructor(private componentFactory: JitComponentFactory, cdr: ChangeDetectorRef) {
        this.#cdr = cdr;
    }

    public ngOnInit(): void {
        if (this.classModifiers.length > 0) {
            this.classModifiers.push(this.elementClass);
            this.elementClass = this.classModifiers.join(' ');
        }
    }

    public async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (this.document !== undefined && null !== changes.document.currentValue) {
            await this.loadDynamicHtml();
        }
    }

    private async loadDynamicHtml(): Promise<void> {
        if (this.htmlAnchor === undefined) return;

        if (ContentComponent.jitComponent instanceof ComponentRef) {
            this.htmlAnchor.clear(); // Clear previous contents
            delete ContentComponent.jitComponent;
        }

        ContentComponent.jitComponent = await this.componentFactory.create(this.htmlAnchor, this.document.body);
        this.htmlAnchor.insert(ContentComponent.jitComponent.hostView);

        this.#cdr.detectChanges();
    }
}
